// Changelog do sistema — mantido à mão a cada entrega. Cada bloco é um dia; dentro dele,
// cada item tem uma tag (novo | atualizado | removido) + um resumo em linguagem de negócio,
// não termo técnico. Ordem: mais recente primeiro.
export const NOVIDADES = [
  {
    data: '2026-07-13',
    itens: [
      {
        tag: 'novo',
        titulo: 'Esqueci minha senha',
        descricao:
          'Na tela de login, "Esqueceu a senha?" agora funciona de verdade: informe seu e-mail, você recebe um link por e-mail e cria uma nova senha sem precisar pedir pra um admin resetar.',
      },
      {
        tag: 'novo',
        titulo: 'Dashboard de Uso na Auditoria',
        descricao:
          'Nova aba dentro de Auditoria mostrando quem está acessando o sistema: logins por usuário, último acesso de cada um, tentativas de login com credenciais erradas, e um gráfico de logins por dia (7/30/90 dias).',
      },
      {
        tag: 'atualizado',
        titulo: 'Correções na tela de Auditoria',
        descricao:
          'A coluna Data/hora, que aparecia como "Invalid Date", agora mostra a data certa. A paginação também deixou de usar o azul padrão do navegador e passou a seguir o mesmo visual do resto do sistema.',
      },
      {
        tag: 'novo',
        titulo: 'Auditor de Hospital',
        descricao:
          'Novo nível de permissão, entre o Auditor AMGestão e a Equipe do Hospital: pode lançar avaliações e gerar o Checklist só no hospital ao qual foi vinculado, mas não altera o escopo, o catálogo nem cria outros usuários. Pensado pra quando um funcionário do próprio hospital é designado pra fazer a auditoria dos setores.',
      },
      {
        tag: 'novo',
        titulo: 'Criado por / Atualizado por no Mapa de Conformidade',
        descricao:
          'Cada requisito no Mapa de Conformidade agora mostra quem registrou a avaliação e, se já foi reavaliado, quem fez a atualização mais recente.',
      },
      {
        tag: 'atualizado',
        titulo: 'Sair do modo apresentação',
        descricao:
          'Agora leva de volta pra tela de escolha de modo (Administração ou Apresentação), em vez de só remover o filtro e continuar na mesma tela.',
      },
      {
        tag: 'atualizado',
        titulo: 'Correção nas Corretivas',
        descricao:
          'Uma avaliação marcada como Conforme ou Supera podia continuar aparecendo na aba de Corretivas por engano, carregando o prazo de uma pendência já resolvida. Corrigido — agora some da lista assim que a reavaliação é salva.',
      },
    ],
  },
  {
    data: '2026-07-10',
    itens: [
      {
        tag: 'novo',
        titulo: 'Gerar Checklist',
        descricao:
          'Nova aba no detalhe do hospital, ao lado de Escopo. Filtre os requisitos do setor que você vai visitar, marque na árvore o que entra no checklist (marcar uma Seção ou Subseção já marca tudo dentro dela) e clique em "Gerar Checklist" para imprimir um formulário em papel — com legenda S/C/PC/NC, espaço para marcar o status à mão e linhas para anotar Fragilidade, Ação proposta, Prazo da ação e Vigência durante a visita ao setor, pra depois lançar no sistema.',
      },
      {
        tag: 'novo',
        titulo: 'Marcar/desmarcar tudo no Escopo',
        descricao:
          'Na aba Escopo, agora tem uma caixinha ao lado de cada Seção e de cada Subseção que marca ou desmarca todos os requisitos dali de uma vez — não precisa mais clicar um por um pra tirar do escopo uma Subseção que não se aplica ao hospital.',
      },
    ],
  },
  {
    data: '2026-07-09',
    itens: [
      {
        tag: 'novo',
        titulo: 'Modo Apresentação',
        descricao:
          'Antes de entrar no sistema, você escolhe entre Modo Administração (acesso total, como sempre) ou Modo Apresentação — nesse, você seleciona um ou mais hospitais e o sistema mostra só eles, o resto fica oculto. Pensado pra quando for apresentar o sistema no telão pra um hospital específico, sem risco de aparecer dado de outro hospital na tela.',
      },
    ],
  },
  {
    data: '2026-07-08',
    itens: [
      {
        tag: 'novo',
        titulo: 'Tela de Auditoria',
        descricao: 'Histórico de quem fez o quê no sistema e quando — visível só para admin.',
      },
      {
        tag: 'novo',
        titulo: 'Redefinir senha de qualquer usuário',
        descricao:
          'Admin e operador agora podem redefinir a senha de qualquer usuário, inclusive da equipe do hospital-cliente — sem precisar saber a senha atual.',
      },
      {
        tag: 'atualizado',
        titulo: 'Usuário admin protegido',
        descricao: 'Quem não é admin não vê mais o usuário admin na lista de usuários, muito menos consegue editá-lo.',
      },
      {
        tag: 'novo',
        titulo: 'Tela de Corretivas próximas do vencimento',
        descricao:
          'Mesma ideia da tela de vencimentos de vigência, só que pra ações corretivas — mostra o que precisa ser feito em cada hospital, com a fragilidade e a ação proposta.',
      },
      {
        tag: 'novo',
        titulo: 'Janela de vencimento configurável',
        descricao:
          'Nas telas de Critérios e Corretivas próximos do vencimento, agora dá pra escolher a janela: 7, 30, 60 ou 90 dias (antes era fixo em 60).',
      },
      {
        tag: 'novo',
        titulo: 'Indicadores analíticos no Dashboard',
        descricao:
          'Gráfico de tendência da carteira mês a mês, ranking dos hospitais com pior % de conformidade, e composição por status (Conforme/Parcial/Não Conforme/Vencido) na Visão Geral do hospital.',
      },
      {
        tag: 'atualizado',
        titulo: 'Fórmula de cálculo padrão',
        descricao: 'Trocada de Ponderada para Binária — a fórmula que a Andrea usa no dia a dia.',
      },
      {
        tag: 'atualizado',
        titulo: 'Atalhos de definição de escopo',
        descricao:
          '"Desmarcar não-CORE" virou três atalhos mais úteis: Marcar apenas CORE, Marcar apenas Obrigatórios, e Marcar CORE Obrigatórios.',
      },
      {
        tag: 'atualizado',
        titulo: 'Selo de obrigatoriedade no Escopo',
        descricao: 'O selo Obrigatório/Aplicável/Não aplicável, que já existia no Catálogo, agora também aparece na tela de Escopo.',
      },
      {
        tag: 'atualizado',
        titulo: 'Visual dos cards de indicador',
        descricao: 'Novo acabamento visual nos cards de KPI do Dashboard.',
      },
    ],
  },
  {
    data: '2026-07-07',
    itens: [
      { tag: 'novo', titulo: 'Sistema em produção', descricao: 'Primeira publicação em amgestao.datafit.pro.' },
      {
        tag: 'atualizado',
        titulo: 'Campos opcionais na avaliação',
        descricao:
          'Ação proposta e Prazo da ação corretiva agora são opcionais ao lançar uma avaliação. Status, Fragilidade e Vigência continuam obrigatórios.',
      },
      {
        tag: 'novo',
        titulo: 'Contagem de CORE no Catálogo',
        descricao: 'Cada Seção e Subseção do Catálogo ONA mostra quantos dos seus requisitos são CORE.',
      },
      {
        tag: 'novo',
        titulo: 'Filtro multiseleção de hospital no Dashboard',
        descricao: 'Antes só dava pra ver um hospital por vez ou todos — agora dá pra escolher qualquer combinação.',
      },
      {
        tag: 'novo',
        titulo: 'Botão "Iniciar Trabalho"',
        descricao: 'Marca o início do trabalho de auditoria num hospital, com data/hora escolhida por você.',
      },
      {
        tag: 'novo',
        titulo: 'Gráficos de barra',
        descricao: 'Comparação entre hospitais no Dashboard, e comparação por seção (1 a 4) na Visão Geral do hospital.',
      },
      { tag: 'removido', titulo: 'Menção a "ONA" no Dashboard', descricao: 'Removida do texto institucional do topo.' },
    ],
  },
];
